/** Router `location.state` when opening match or talent-pool profile details (restore list URL on back). */
export type MatchDetailsLocationState = {
  matchDetailsReturnPath?: string;
  /** Original list URL query (e.g. `?tp_job=…&tp_status=…&lang=de`) to restore after back. */
  matchDetailsReturnSearch?: string;
};

/** Query param on `/company/recruiting/match/:id` — which list opened details (reliable vs `location.state`). */
export const MATCH_DETAILS_RETURN_TO_PARAM = 'returnTo';
/** Query param used when returning from details to focus a specific board card. */
export const MATCH_DETAILS_FOCUS_MATCH_PARAM = 'focusMatchId';

export const MATCH_DETAILS_FROM_TALENT_POOL = 'talent-pool';
export const MATCH_DETAILS_FROM_MATCHES = 'matches';

/** Path for `/company/recruiting/match/:id` when opening from the matches board (preserves list query + back/focus). */
export function buildMatchDetailsHrefFromMatchesBoard(matchId: string, locationSearch: string): string {
  const raw = locationSearch.startsWith('?') ? locationSearch.slice(1) : locationSearch;
  const qs = new URLSearchParams(raw);
  qs.set(MATCH_DETAILS_RETURN_TO_PARAM, MATCH_DETAILS_FROM_MATCHES);
  qs.set(MATCH_DETAILS_FOCUS_MATCH_PARAM, matchId);
  return `/company/recruiting/match/${matchId}?${qs.toString()}`;
}
